import { useState } from "react";

import { RadioGroup } from "@headlessui/react";

import { Description } from "../common/description";

const settings = [
  {
    name: "TOTP",
    description: "Use Google Authenticator or similar",
  },
  {
    name: "PUSH",
    description: "Use Auth0 Guardian to recieve push notifications",
  },
  {
    name: "SMS",
    description: "Use SMS sent to your mobile phone (insecure)",
  },
  {
    name: "VOICE",
    description: "Get a phone call to your mobile or landline phone (insecure)",
  },
];

function classNames(...classes: any) {
  return classes.filter(Boolean).join(" ");
}

export default function AuthenticatorTypeSelector({ onSelect }: any) {
  const [selected, setSelected] = useState(settings[0]);

  const handleOnSelect = (option: any) => {
    setSelected(option);
    onSelect(option);
  };

  return (
    <div className="mt-4">
      <Description text="Authenticator type to use" />
      <RadioGroup value={selected} onChange={handleOnSelect} className="mt-4">
        <RadioGroup.Label className="sr-only">
          Authenticator type
        </RadioGroup.Label>
        <div className="bg-white rounded-md -space-y-px">
          {settings.map((setting, settingIdx) => (
            <RadioGroup.Option
              key={setting.name}
              value={setting}
              className={({ checked }) =>
                classNames(
                  settingIdx === 0 ? "rounded-tl-md rounded-tr-md" : "",
                  settingIdx === settings.length - 1
                    ? "rounded-bl-md rounded-br-md"
                    : "",
                  checked
                    ? "bg-indigo-50 border-indigo-200 z-10"
                    : "border-gray-200",
                  "relative border p-4 flex cursor-pointer focus:outline-none"
                )
              }
            >
              {({ active, checked }) => (
                <>
                  <span
                    className={classNames(
                      checked
                        ? "bg-indigo-600 border-transparent"
                        : "bg-white border-gray-300",
                      active ? "ring-2 ring-offset-2 ring-indigo-500" : "",
                      "h-4 w-4 mt-0.5 cursor-pointer rounded-full border flex items-center justify-center"
                    )}
                    aria-hidden="true"
                  >
                    <span className="rounded-full bg-white w-1.5 h-1.5" />
                  </span>
                  <div className="ml-3 flex flex-col">
                    <RadioGroup.Description
                      as="span"
                      className={classNames(
                        checked ? "text-indigo-700" : "text-gray-500",
                        "block text-sm"
                      )}
                    >
                      {setting.description}
                    </RadioGroup.Description>
                  </div>
                </>
              )}
            </RadioGroup.Option>
          ))}
        </div>
      </RadioGroup>
    </div>
  );
}
